<template>
  <div class="box">
    <div id="app-home">
      <div class="content">
        <div class="con-time">
          <span @click.stop="openPicker"
            >{{ currentDate }}<span v-if="currentDate !== '全部'">年</span>
            <i v-if="timePicker !== true"><van-icon name="arrow-down" /></i>
            <i v-else><van-icon name="arrow-up" /></i>
          </span>
          <van-popup
            v-model="timePicker"
            round
            get-container="body"
            position="bottom"
          >
            <van-picker
              show-toolbar
              title="选择年份"
              :default-index="defaultIndex"
              :columns="columns"
              @cancel="timePicker = false"
              @confirm="confirmDate"
            />
          </van-popup>
        </div>
        <div class="con-table">
          <el-table
            :data="tableData"
            style="width: 100%"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="holidayType" label="类型"></el-table-column>
            <el-table-column prop="holidayNum" label="剩余">
              <template slot-scope="{ row }">
                {{ row.holidayNum }}小时
              </template>
            </el-table-column>
            <el-table-column prop="expiryDate" label="截止日期">
            </el-table-column>
          </el-table>
        </div>
        <div class="footer" v-if="baseinfo.length>0">
          <span>*</span>基于您在考勤系统中的记录显示，截止到目前为止,
          <a v-for="(item,ind) in baseinfo" :key="ind">
            {{item.currentYear}}年还有年假{{item.leaveBal}}小时与调休{{item.otBal}}小时，请于{{item.expiryDate}}前使用,
          </a>逾期仍未使用的部分则视为自动放弃。
        </div>
      </div>
      <div class="submit">
        <!-- <el-button class="button" v-if="flag" @click="toUrl">确认</el-button> -->
        <el-button
          class="button1"
          v-if="!flag && confirmed === '1'"
          @click="toUrl"
          >已确认</el-button
        >
        <el-button
          class="button2"
          v-if="!flag && confirmed === '0'"
          @click="queryOne"
          >未确认</el-button
        >
        <el-button
          class="button3"
          v-if="!flag && confirmed === '2'"
          @click="queryTwo"
          >已过期</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
import { getToken } from "@/utils/cookie";
export default {
  name: "home",
  data() {
    return {
      currentDate: moment(new Date()).add(-1, "y").format("YYYY"), // 当前展示时间
      timePicker: false,
      columns: [], //
      defaultIndex: 0,
      createdate: "",
      tableData: [],
      confirmed: null,
      flag: false,
      baseinfo:[]
    };
  },
  created() {
    if (this.$route.query.month) {
      this.currentDate = "全部";
      this.flag = true;
    } else {
      this.flag = false;
    }
  },
  mounted() {
    this.init();
    this.getList();
  },
  methods: {
    //未确认
    queryOne() {
      const time = moment(new Date()).format("YYYY-MM");
      api.confirmHolidayMsg({ empNo: getToken(), month: time }).then((data) => {
        console.log(data);
        this.$message({
          type: "success",
          message: "确认成功",
          duration: 1000,
        });
        this.getList();
      });
    },
    //已过期
    queryTwo() {
      this.$message({
        type: "warning",
        message: "该假期推送已过期",
        duration: 1000,
      });
    },
    //返回
    toUrl() {
      this.$router.go(-1);
    },
    //表格行样式
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 1) {
        return "table-row";
      }
      return "";
    },
    //初始化年份
    initYear() {
      const lastYear = moment(new Date()).year();
      const createdate = moment(this.createdate).year();
      let outYear = lastYear - createdate + 1;
      this.columns = [...new Array(outYear).keys()]
        .map((k) => {
          return `${lastYear - k}年`;
        })
        .reverse();
      this.columns.push("全部");
    },
    //选择年份
    openPicker() {
      const currentIndex = this.columns.findIndex((item) => {
        return item === (this.currentDate || `${moment().year()}年`);
      });
      this.defaultIndex = currentIndex > -1 ? currentIndex : 0;
      this.timePicker = true;
    },
    //确认选择年份
    confirmDate(value) {
      const item = value.replace("年", "");
      this.currentDate = item;
      this.timePicker = false;
      this.getList();
    },
    //获取假期列表
    init() {
      api.selectEmployeeWithLeader({ empNo: getToken() }).then((data) => {
        this.createdate = data.data.createdate;
        setTimeout(() => {
          this.initYear();
        }, 500);
      });
    },
    //获取假期
    getList() {
      api
        .selectHolidayRecord({
          empNo: getToken(),
          year: this.currentDate === "全部" ? "all" : this.currentDate,
        })   
        .then((data) => {
          const res = data.data.hrLeaveBalanceList
          this.tableData = []
          res.forEach(item=>{
            if(item.holidayNum != 0){
              this.tableData.push(item)
            }
          })
          // this.tableData = data.data.hrLeaveBalanceList; 
          this.baseinfo = data.data.hrLeaveBalanceObj;
          this.baseinfo.forEach(item=>{
            item.expiryDate=moment(item.expiryDate).format("YYYY年MM月DD日")
          })
          this.confirmed = this.tableData[0].confirmed;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
#app-home {
  font-size: 16px * $zoom;
  position: relative;
  background: rgba(247, 249, 250, 1);
  min-height: 100vh;
  padding: 20px;
}
.content {
  background: #fff;
  padding: 20pt 20pt;
  .con-time {
    font-size: 14pt;
    color: rgba(150, 155, 158, 1);
    float: right;
    margin: -6pt 12pt 12pt 0;
  }
}
.footer {
  font-size: 8pt;
  color: #ccc;
  line-height: 36px;
  margin-top: 20px;
  span {
    color: rgba(244, 35, 35, 1);
  }
}

.con-table {
  ::v-deep .el-table .table-row {
    background-color: #ecf5f2;
  }
  ::v-deep .cell {
    text-align: center;
  }
  ::v-deep th.el-table__cell {
    background-color: #ecf5f2;
  }
  ::v-deep .el-table th.el-table__cell.is-leaf {
    border: none !important;
  }
}
.submit {
  position: absolute;
  bottom: 100px;
  width: 80%;

  .button,
  .button1,
  .button2,
  .button3 {
    width: 100%;
    // background: rgba(78, 162, 124, 1);
    color: #fff;
    height: 80px;
    font-size: 30px;
    padding-top: 15px;
    border-radius: 20px;
    margin-left: 10%;
  }
  .button,
  .button1 {
    background: rgba(78, 162, 124, 1);
  }
  .button2 {
    background: #ccc;
    // color: black;
  }
  .button3 {
    background: rgb(194, 138, 33);
  }
}
</style>
